import { toDateTime } from "Helpers/Format";

const formatDate = (value) => (value ? toDateTime(value) : "");

/*
 * De que SESSÃO é a pendência (24/09/2026 — R5).
 *
 * Antes a tela dizia Projeto, Seletiva, Origem e Data: o admin sabia QUEM
 * enviou, mas não O QUE era. As três pendências do servidor de dev eram todas
 * mensagens, e não havia como perceber isso na tela.
 *
 * ⚠️ Os rótulos espelham SECTION_LABELS do backend
 * (src/config/notificationMessageTypes.js), que também nomeia a sessão no
 * assunto do e-mail. Dois vocabulários para a mesma sessão é como a fila passa a
 * chamar de "Álbum" o que o e-mail chama de outra coisa.
 *
 * O `kind` já vinha em cada linha (PendingApprovalService.list) — não há
 * requisição nova, e o campo "Pesquisar" da coluna vem de graça do `useFilters`
 * da Table.
 */
const KIND_LABELS = {
  message: "Mensagem",
  album: "Álbum",
  schedule: "Cronograma",
  report: "Relatórios",
};

const kindLabel = (row) => KIND_LABELS[row.kind] || "—";

/*
 * Fila de aprovações do admin (parte 4 — D7).
 *
 * ⚠️ A coluna "Seletiva" é determinística só em MENSAGENS: elas são ancoradas
 * no vínculo (project_conversations.project_sponsor_id → select_project_id).
 * Álbum, Cronograma e Relatórios pertencem ao PROJETO, não ao vínculo — o
 * backend devolve null e a célula mostra "—" (RN9). Não é dado faltando.
 */
export const downloadColumns = [
  { Header: "Projeto", accessor: "project_name" },
  { Header: "Sessão", accessor: kindLabel },
  {
    Header: "Seletiva",
    accessor: (row) => row.select_project_name || "—",
  },
  { Header: "Origem", accessor: "origin" },
  { Header: "Data", accessor: (row) => formatDate(row.created_at) },
];

export const columns = [
  { Header: "Projeto", accessor: "project_name" },
  { Header: "Sessão", accessor: kindLabel },
  {
    Header: "Seletiva",
    accessor: (row) => row.select_project_name || "—",
  },
  { Header: "Origem", accessor: "origin" },
  { Header: "Data", accessor: (row) => formatDate(row.created_at) },
];
